import React        from 'react'

const Content = props => {
    return (
        <div className="blogs-container-content">
            { props.children }
        </div>
    )
}

export default Content
